export { Badge, badgeVariants } from './badge';
export type { BadgeProps } from './badge';
